import script from "./Transaction.vue?vue&type=script&setup=true&lang=js"
export * from "./Transaction.vue?vue&type=script&setup=true&lang=js"

import "./Transaction.vue?vue&type=style&index=0&id=502755b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-502755b3"]])

export default __exports__